import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class DriverWageDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      data: props.data || null,
    }
  }

  handleCalculateWageButtonClicked() {
    this.calculateWage();
  }

  handleApproveWageButtonClicked() {
    this.approveWage();
  }

  handleSetWageAsPaidButtonClicked() {
    this.setWageAsPaid();
  }

  setWageAsPaid() {
    var that = this;
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/set-as-paid',
        data: {
          api_token: window.api_token,
          wage_paid_reference: $(
            '#driver-wage-'+this.state.data.id+' [name=wage_paid_reference]').val()
        },
        cache: false,
        method: 'post',
      })
      .done(function(wageJson) {
        that.setState({data: wageJson, isLoading: false});
      });
  }

  calculateWage() {
    var that = this;
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/calculate',
        data: {api_token: window.api_token},
        cache: false
      })
      .done(function(calculatedWageJson) {
        that.setState({data: calculatedWageJson, isLoading: false});
      });
  }

  approveWage() {
    var that = this;
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/approve',
        data: {api_token: window.api_token},
        cache: false,
        method: 'post',
      })
      .done(function(wageJson) {
        that.setState({data: wageJson, isLoading: false});
      });
  }

  render() {
    let BreakdownItems = [];
    var that = this;

    if (this.state.data.breakdown &&
        (this.state.data.breakdown.length > 0)) {

      let i = 0;
      this.state.data.breakdown.forEach(function(breakdownItem) {
        BreakdownItems.push(<div key={that.state.data.id+'-'+i++} className="row">
          <div className="col-md-2">
            {breakdownItem.date}
          </div>

          <div className="col-md-2">
            {breakdownItem.type}
          </div>

          <div className="col-md-2">
            {breakdownItem.category}
          </div>

          <div className="col-md-3">
            {breakdownItem.description}
          </div>

          <div className={'col-md-3 '+breakdownItem.type+'-debit'}>
            {breakdownItem.formatted_currency_string}
          </div>
        </div>);
      });
    }

    return (
      <div className="text-left" id={'driver-wage-'+this.state.data.id}>

        <div className="row">
          <div className="col-md-6">
            <button
              className="btn btn-lg btn-primary"
              onClick={(e) => {this.handleCalculateWageButtonClicked()}}
              >
              <i className="fa fa-calculator"></i> Calculate Wage
            </button>
          </div>
        </div>

        {(this.state.data.calculated == 0) ?
            <p>Not calculated yet</p>
        :

      <div>

       {(this.state.data.breakdown && this.state.data.breakdown.length > 0) ?
         <div className="wage-details-calculated-wage-breakdown-container">
          <div className="row">
            <div className="col-md-12">
              <h1>Wage</h1>
<div className="row wage-details-wage-breakdown-table-headers">
  <div className="col-md-2">
  date
  </div>

  <div className="col-md-2">
  type
  </div>

  <div className="col-md-2">
  category
  </div>

  <div className="col-md-3">
  description
  </div>

  <div className="col-md-3">
  amount
  </div>
</div>
              {BreakdownItems}


              <h3 className="wage-total-payable-container">Total Amount Payable:
                <i className="fa fa-pound-sign"></i>
              <span>
                {(this.state.data.wage_total_payable_in_pence / 100).toFixed(2)}
              </span>
              </h3>
            </div>
          </div>
        </div>
         :
         ''
       }

       <div className="row">
          <div className="col-md-4">
             <div className="wage-details-wage-approval-status-container">
              {(this.state.data.accountant_approved == 0) ?
                <p>
                  This Wage is not approved by an accountant.<br />
                  <button className="btn btn-lg btn-dark"
              onClick={(e) => {this.handleApproveWageButtonClicked()}}>
                    <i className="fa fa-check"></i> Click to Approve
                  </button>
                </p>
             :
              <button className="btn btn-lg btn-success">
              <i class="fa fa-check"></i> Accountant Approved
              </button>
            }
              </div>
          </div>
          <div className="col-md-4">
            <div className="wage-details-wage-approval-status-container">
             {(this.state.data.driver_approved == 0) ?
              <p>
                This Wage is not approved by the driver.<br />
              </p>
           :
            <button className="btn btn-lg btn-success">
              <i className="fa fa-check"></i> Driver Approved
            </button>
          }
            </div>
          </div>
          <div className="col-md-4">
            <div className="wage-details-wage-approval-status-container">
             {(this.state.data.driver_approved == 1 &&
               this.state.data.accountant_approved == 1) ?

               (this.state.data.wage_paid == 0) ?
               <p>
               <input type="text"
                name="wage_paid_reference" placeholder="Wage paid reference"
                className="form-control form-control-lg"
                 />
               <button className="btn btn-lg btn-primary"
               onClick={(e) => {this.handleSetWageAsPaidButtonClicked()}}
               >
                <i className="fa fa-double-check"></i> Set DriverWage as paid
                </button>
               </p>
               :
               <p>
                  <button className="btn btn-lg btn-success">
                    <i className="fa fa-check-double"></i> Driver Wage Paid
                  </button>
               <input type="text"
                name="wage_paid_reference" value={this.state.data.wage_paid_reference}
                 placeholder="Wage paid reference"
                className="form-control form-control-lg"
                 />
                </p>

               :
               <strong>Waiting for Driver Approval</strong>
             }
            </div>
          </div>
        </div>

      </div>
    }
      </div>
    );
  }
}
